module.exports = __webpack_public_path__ + "img/11_108.839e2145.png";